import React from "react";

const PrimaryButton = ({ title, onClick }) => (
    <button title={title} onClick={onClick} className="mdl-button mdl-button--fab fab-mini">
        <i className="material-icons text-success">add</i>
    </button>
);

export default PrimaryButton;
